export default __webpack_public_path__ + "static/media/Phone.fee06af2.svg";